import { AssessmentDefinition } from "../../../../../noctem-lib/src/core/contracts/models.calculations";


export const preFieldSurveyMedic: AssessmentDefinition = {
  name: 'pre-field-survey-medic',
  description: 'Pre Field Survey Medic',
  instructions: null,
  questions: []
};
